export default __webpack_public_path__ + "static/media/service_structure.1923978a.png";